import { Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core"

// Canais em que o produto / passo de montagem é vendido (Produto.canais e
// GrupoOpcoes.canais no backend, coluna canais_venda). Gravado como CSV;
// null = em todos. Quem recorta o cardápio por canal é o PDVoz.
export const CANAIS_VENDA = [
    { valor: "DELIVERY", rotulo: "Delivery", ajuda: "site / app do cliente" },
    { valor: "REGISTRADOR", rotulo: "Registrador", ajuda: "atendente, garçom, maquininha" },
    { valor: "TOTEM", rotulo: "Totem", ajuda: "autoatendimento" },
]

const TODOS = CANAIS_VENDA.map(c => c.valor)

// CSV do backend (null/"" = todos) → lista marcada
export const canaisDoBackend = csv => {
    if (!csv || !String(csv).trim()) return [...TODOS]
    const marcados = String(csv)
        .split(",")
        .map(c => c.trim().toUpperCase())
        .filter(c => TODOS.includes(c))
    return marcados.length ? marcados : [...TODOS]
}

// lista marcada → valor enviado (todos = null)
export const canaisParaBackend = marcados =>
    marcados.length === TODOS.length ? null : TODOS.filter(c => marcados.includes(c)).join(",")

export default function CanaisVenda({ value, onChange, titulo = "Canais de venda" }) {
    const alternar = canal => {
        onChange(value.includes(canal) ? value.filter(c => c !== canal) : [...value, canal])
    }

    return (
        <Grid item xs={12}>
            <Typography variant="subtitle2">{titulo}</Typography>
            <Grid container>
                {CANAIS_VENDA.map(c => (
                    <Grid item xs={12} sm={4} key={c.valor}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={value.includes(c.valor)}
                                    onChange={() => alternar(c.valor)}
                                />
                            }
                            label={
                                <span>
                                    {c.rotulo}{" "}
                                    <Typography variant="caption" color="textSecondary">
                                        ({c.ajuda})
                                    </Typography>
                                </span>
                            }
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )
}
